import { Modal, Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './ModalFlat.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import useFlatsGrid from '../../../../../HousingStock/queries/useFlatsGrid';
import { getPreparedFlatsGrid } from '../../../../../HousingStock/pages/HousePage/utils';
import { requestsActions } from '../../../../requests.actions';
import InfoRequest from './components/InfoRequest/InfoRequest';
import MainFlatsGrid from './components/MainFlatsGrid/MainFlatsGrid';
import { createFullAddress } from '../../../../../../helpers/createFullAddress';

const ModalFlat = () => {
  const dispatch = useDispatch();

  const showModalChess = useSelector(
    (state) => state.requestsStore.showModalChess
  );

  const { record } = showModalChess || {};

  const [flatsGridData, setFlatsGridData] = useState([]);

  const { data: flats, isFetching } = useFlatsGrid(record?.houseId, {
    enabled: !!record?.houseId,
  });

  const handleClose = () => {
    dispatch(requestsActions.setShowModalChess(null));
  };

  const addressId = record?.addressId || null;

  const baseActiveFlat = useMemo(() => {
    if (!addressId || !flats || !flats.length) return null;

    return flats?.find((flat) => flat.addressId === addressId);
  }, [flats, addressId]);

  useEffect(() => {
    if (flats?.length) {
      const { flatsGridData } = getPreparedFlatsGrid(flats);

      setFlatsGridData(flatsGridData);
    }
  }, [dispatch, flats]);

  return (
    <Modal
      visible={!!record}
      onCancel={handleClose}
      onOk={handleClose}
      destroyOnClose
      width="90%"
      title={`Шахматка по адресу ${createFullAddress(record)}`}
      bodyStyle={{
        maxHeight: '80vh',
        overflowY: 'auto',
      }}
    >
      <div className={styles.root}>
        <InfoRequest record={record} />
        {isFetching ? (
          <Spin />
        ) : (
          <MainFlatsGrid
            flatsGridData={flatsGridData}
            baseActiveFlat={baseActiveFlat}
          />
        )}
      </div>
    </Modal>
  );
};

export default ModalFlat;
